import { render, staticRenderFns } from "./displayInfo.vue?vue&type=template&id=612fb416&scoped=true"
import script from "./displayInfo.vue?vue&type=script&lang=js"
export * from "./displayInfo.vue?vue&type=script&lang=js"
import style0 from "./displayInfo.vue?vue&type=style&index=0&id=612fb416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fb416",
  null
  
)

export default component.exports